<template>
  <div class="body_right">
    <div class="body_right_first">
      <div class="img"><img src="../../../assets/imgs/icon_open.png"></div>
      <div class="title">お気に入り</div>
    </div>
    <div class="body_right_second">
      <div class="body_right_second_scrollbar" ref="veriface" v-loading="Loading">
        <collect-item v-for="(item,index) in list" :key="index" :data="item"></collect-item>
      </div>
    </div>
  </div>
</template>

<script>
import * as json from '@/assets/js/json'
import collectItem from '@/components/collectItem/index'
  export default {
    components: {
      collectItem
    },
    data () {
      return {
        size: 10,
        page: 1,
        list: [],
        Loading: true
      }
    },
    created () {
      this.fetch()
    },
    mounted() {
      this.$refs.veriface.addEventListener('scroll', (e)=>{
        // console.log(e,'滚动条滚动触发')
        var scrollTop = e.target.scrollTop
        var windowHeight = e.target.clientHeight
        var scrollHeight = e.target.scrollHeight
        console.log(scrollTop,windowHeight,scrollHeight,'123')
        console.log(scrollTop+windowHeight,scrollHeight)
        if(scrollTop+windowHeight > scrollHeight-1){
            // 当前滚动条已经触底
            this.page ++ 
            this.getList()
        } else {
        }
      })
    },
    methods: {
      fetch(){
        let Option = {
          size: this.size,
          current: this.page
        }
        this.Loading = true
        json.post('/api/member/profile/favorite/detail/list', Option).then((res) => {
          if (res.data.success) {
            this.list = res.data.data.favorites
            this.Loading = false
          }
        })
      },
      getList(){
        let Option = {
          size: this.size,
          current: this.page
        }
        this.Loading = true
        json.post('/api/member/profile/favorite/detail/list', Option).then((res) => {
          if (res.data.success) {
            let mergedArray= null
            mergedArray = this.list.concat(res.data.data.favorites) 
            this.list = mergedArray
            this.Loading = false
          }
        })
      },
      deleteArticle(id){
        const Option = {
          articleId : id
        }
        json.post('/api/member/article/favorite/delete', Option).then((res) => {
          if (res.data.success) {
            this.fetch()
          }
        })
      },
      deletePost(id){
        const Option = {
          postId : id
        }
        json.post('/api/member/post/favorite/delete', Option).then((res) => {
          if (res.data.success) {
            this.fetch()
          }
        })
      }
    }
  }
</script>

<style src="@/pages/homePage/notice/likeNotice/index.css" scoped>
</style>

